import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import DehazeIcon from '@mui/icons-material/Dehaze';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Grid, Modal, styled, useTheme } from '@mui/material';
import { CartMenuItem } from 'components/shared/CartMenuItem/CartMenuItem';
import React, { useState } from 'react';
import useMobileMenu from '../../../../hooks/useMobileMenu';
import { LogoWrapperB2B } from '../../../shared/logos/LogoWrapperB2B';
import { SearchInput } from '../SearchInput/SearchInput';
import { CollectionMobileDrawer } from './CollectionMobileDrawer';
import { ProfileMobileDrawer } from './ProfileMobileDrawer';

const HeaderContainer = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    boxShadow: '0 1px 3px #0000001a',
    padding: '0 15px',
}));

const DashboardContent = styled(Box)(() => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '100%',
}));

const MenuContent = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
}));

const StyledButton = styled(Button)(() => ({
    margin: '0 5px 0 5px',
}));

export const ProfileHeaderMobile: React.FC<{ displaySearch?: boolean }> = (
    props
) => {
    const { displaySearch } = props;

    const theme = useTheme();

    const mobileMenu = useMobileMenu();

    const [isSearchOpen, setSearchOpen] = useState<boolean>(false);

    return (
        <>
            <HeaderContainer>
                {displaySearch && (
                    <Grid item xs>
                        <MenuContent>
                            <StyledButton
                                onClick={() => mobileMenu.showMainMenu(true)}
                            >
                                <DehazeIcon color={'primary'} />
                            </StyledButton>

                            <StyledButton
                                onClick={setSearchOpen.bind(this, true)}
                            >
                                <SearchIcon color={'primary'} />
                            </StyledButton>

                            <Modal
                                open={isSearchOpen}
                                onClose={setSearchOpen.bind(this, false)}
                            >
                                <Box
                                    bgcolor="white"
                                    borderBottom={`1px solid ${theme.palette.grey[400]}`}
                                    padding={2}
                                    paddingTop={4}
                                >
                                    <SearchInput
                                        callback={setSearchOpen.bind(
                                            this,
                                            false
                                        )}
                                    />
                                </Box>
                            </Modal>
                        </MenuContent>
                    </Grid>
                )}
                <Grid item xs>
                    <LogoWrapperB2B />
                </Grid>
                <Grid item xs>
                    <DashboardContent>
                        <StyledButton
                            onClick={() => mobileMenu.showProfileMenu(true)}
                        >
                            <AccountCircleOutlinedIcon color={'primary'} />
                        </StyledButton>
                        <CartMenuItem />
                    </DashboardContent>
                </Grid>
            </HeaderContainer>
            <CollectionMobileDrawer />
            <ProfileMobileDrawer />
        </>
    );
};
